import { createGlobalStyle } from 'styled-components';

const Root = createGlobalStyle`
  html {
    font-size: 100%;
    box-sizing: border-box;
    height: 100%;
    scroll-behavior: smooth;
  }
  body {
    margin: 0;
    box-sizing: border-box;
    min-height: 100%;
    text-rendering: optimizeLegibility;
    font-family: 'Poppins', sans-serif;
  }
  div[data-js="app"]{
    overflow-x: hidden;
    overflow-y: scroll;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin: 0;
    padding: 0;
    border: 0;
  }

  a {
    text-decoration: inherit;
    color: inherit;
    &:hover {
      cursor: pointer;
    }
  }

  ul,
  ol {
    padding-left: 0;
    margin-top: 0;
    margin-bottom: 0;
    list-style: none;
  }
  img {
    max-width: 100%;
    height: auto;
    display: inline-block;
    vertical-align: middle;
  }
  strong {
    font-weight: bold;
  }

  em {
    font-style: italic;
  }

  *:focus {
    outline:none !important;
    outline-width: 0 !important;
    box-shadow: none;
  }
  [contenteditable="true"]:focus {
    outline: none;
  }

  @font-face {font-family: "FeltThatW01-Regular";
    src: url("https://db.onlinewebfonts.com/t/f0c9b1eb5382d24dc4466ca3db9aef93.eot"); /* IE9*/
    src: url("https://db.onlinewebfonts.com/t/f0c9b1eb5382d24dc4466ca3db9aef93.eot?#iefix") format("embedded-opentype"), /* IE6-IE8 */
    url("https://db.onlinewebfonts.com/t/f0c9b1eb5382d24dc4466ca3db9aef93.woff2") format("woff2"), /* chrome firefox */
    url("https://db.onlinewebfonts.com/t/f0c9b1eb5382d24dc4466ca3db9aef93.woff") format("woff"), /* chrome firefox */
    url("https://db.onlinewebfonts.com/t/f0c9b1eb5382d24dc4466ca3db9aef93.ttf") format("truetype"), /* chrome firefox opera Safari, Android, iOS 4.2+*/
    url("https://db.onlinewebfonts.com/t/f0c9b1eb5382d24dc4466ca3db9aef93.svg#FeltThatW01-Regular") format("svg"); /* iOS 4.1- */
  }

  @font-face {
    font-family: 'DomaineSansText-MediumItalic';
    src: url("./src/assets/fonts/domaine/Domaine-Sans-Text-Medium-Italic.eot"), url("./src/assets/onts/domaine/Domaine-Sans-Text-Medium-Italic.eot?#iefix") format('embedded-opentype'), url("./src/assets/fonts/domaine/Domaine-Sans-Text-Medium-Italic.woff2") format('woff2'), url("./src/assets/fonts/domaine/Domaine-Sans-Text-Medium-Italic.woff") format('woff'), url("./src/assets/fonts/domaine/Domaine-Sans-Text-Medium-Italic.ttf") format('truetype'), url("./src/assets/fonts/domaine/Domaine-Sans-Text-Medium-Italic.otf");
    font-style: italic;
  }

  @font-face {
    font-family: 'DomaineSansText-Medium';
    src: url("./src/assets/fonts/domaine/Domaine-Sans-Text-Medium.eot"), url("./src/assets/fonts/domaine/Domaine-Sans-Text-Medium.eot?#iefix") format('embedded-opentype'), url("./src/assets/fonts/domaine/Domaine-Sans-Text-Medium.woff2") format('woff2'), url("./src/assets/fonts/domaine/Domaine-Sans-Text-Medium.woff") format('woff'), url("./src/assets/fonts/domaine/Domaine-Sans-Text-Medium.ttf") format('truetype'), url("./src/assets/fonts/domaine/Domaine-Sans-Text-Medium.otf") format('otf');
  }

  @font-face {
    font-family: 'DomaineSansText-Regular';
    src: url("./src/assets/fonts/domaine/Domaine-Sans-Text-Regular.eot"), url("./src/assets/fonts/domaine/Domaine-Sans-Text-Regular.eot?#iefix") format('embedded-opentype'), url("./src/assets/fonts/domaine/Domaine-Sans-Text-Regular.woff2") format('woff2'), url("./src/assets/fonts/domaine/Domaine-Sans-Text-Regular.woff") format('woff'), url("./src/assets/fonts/domaine/Domaine-Sans-Text-Regular.ttf") format('truetype'), url("./src/assets/fonts/domaine/Domaine-Sans-Text-Regular.otf") format('otf');
  }

  @font-face {
    font-family: 'DomaineSansText-BlackItalic';
    src: url("./src/assets/fonts/domaine/Domaine-Sans-Text-Black-Italic.eot"), url("./src/assets/fonts/domaine/Domaine-Sans-Text-Black-Italic.?#iefix") format('embedded-opentype'), url("./src/assets/fonts/domaine/Domaine-Sans-Text-Black-Italic.woff2") format('woff2'), url("./src/assets/fonts/domaine/Domaine-Sans-Text-Black-Italic.woff") format('woff'), url("./src/assets/fonts/domaine/Domaine-Sans-Text-Black-Italic.ttf") format('truetype'), url("./src/assets/fonts/domaine/Domaine-Sans-Text-Black-Italic.otf") format('otf');
  }

  @font-face {
    font-family: 'DomaineSansText-BoldItalic';
    src: url("./src/assets/fonts/domaine/Domaine-Sans-Text-Bold-Italic.eot"), url("./src/assets/fonts/domaine/Domaine-Sans-Text-Bold-Italic.eot?#iefix") format('embedded-opentype'), url("./src/assets/fonts/domaine/Domaine-Sans-Text-Bold-Italic.woff2") format('woff2'), url("./src/assets/fonts/domaine/Domaine-Sans-Text-Bold-Italic.woff") format('woff'), url("./src/assets/fonts/domaine/Domaine-Sans-Text-Bold-Italic.ttf") format('truetype'), url("./src/assets/fonts/domaine/Domaine-Sans-Text-Bold-Italic.otf") format('otf');
  }
`;
export default Root;
